module.exports = __webpack_public_path__ + "static/img/home_process_login_1.f7e86dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/official/home_process_login_1.png
// module id = 9bE5
// module chunks = 1